document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document
      .querySelectorAll(".banner-swiper-active")
      .forEach(function (slider) {
        const prev = slider.querySelector(".cs-featured-swiper-button-prev");
        const next = slider.querySelector(".cs-featured-swiper-button-next");
        const pagination = slider.querySelector(".rbt-swiper-pagination");

        if (!prev || !next || !pagination) return;

        new Swiper(slider, {
          slidesPerView:
            parseInt(slider.getAttribute("data-slides-per-view")) || 3,
          autoplay:
            slider.getAttribute("data-autoplay") === "yes"
              ? { delay: 3000 }
              : false,
          navigation: {
            nextEl: next,
            prevEl: prev
          },
          pagination: {
            el: pagination,
            clickable: true
          },
          loop: true,
          spaceBetween: 30
        });
      });
  }, 500);
});
